/* eslint-disable */

import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import {
  doc,
  getDoc,
  arrayUnion,
  writeBatch,
  increment,
  Timestamp,
  setDoc,
} from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, auth } from "../firebase"; // Adjust based on your Firebase config
import stringSimilarity from "string-similarity";
import { v4 as uuidv4 } from "uuid";

// ─── Stripe-inspired form CSS (injected when form is shown) ─────────────────
const FORM_CSS = `
  .offer-form-root *, .offer-form-root *::before, .offer-form-root *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .offer-form-root {
    --bg: #f6f9fc;
    --surface: #ffffff;
    --border: #e3e8ef;
    --border-focus: #6772e5;
    --text-primary: #1a1f36;
    --text-secondary: #697386;
    --text-muted: #9da8ba;
    --accent: #6772e5;
    --accent-light: #eef0fd;
    --ok: #1ea672;
    --ok-light: #e6f7f0;
    --flag: #e3a008;
    --flag-light: #fef9e7;
    --danger: #e5424d;
    --danger-light: #fdf2f3;
    --radius-sm: 6px;
    --radius-md: 10px;
    --radius-lg: 14px;
    --shadow-sm: 0 1px 3px rgba(0,0,0,.06), 0 1px 2px rgba(0,0,0,.04);
    --shadow-md: 0 4px 16px rgba(0,0,0,.08);
    --shadow-lg: 0 8px 32px rgba(0,0,0,.1);
    --font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    --mono: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    --text-xs: 0.75rem;
    --text-sm: 0.875rem;
    --text-base: 1rem;
    --text-lg: 1.125rem;
    --text-2xl: 1.5rem;
    --text-3xl: 1.875rem;
    --text-4xl: 2.25rem;
    --weight-normal: 400;
    --weight-medium: 500;
    --weight-semibold: 600;
    --weight-bold: 700;
  }
  .offer-form-root .gradient-text {
    background: linear-gradient(to right, #2563eb, #9333ea);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .offer-form-root .form-inner { padding: 40px 20px 80px; display: flex; flex-direction: column; align-items: center; width: 100%; }
  .offer-form-root .form-header { width: 100%; max-width: 680px; margin-bottom: 32px; }
  .offer-form-root .form-header__eyebrow { display: inline-flex; align-items: center; gap: 6px; font-size: var(--text-xs); font-weight: var(--weight-semibold); letter-spacing: .08em; text-transform: uppercase; color: var(--accent); margin-bottom: 10px; }
  .offer-form-root .form-header__eyebrow-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--accent); }
  .offer-form-root .form-header__title { font-size: var(--text-3xl); font-weight: var(--weight-bold); letter-spacing: -.02em; color: var(--text-primary); line-height: 1.2; margin-bottom: 8px; }
  @media (min-width: 768px) { .offer-form-root .form-header__title { font-size: var(--text-4xl); } }
  .offer-form-root .form-header__sub { font-size: var(--text-base); color: var(--text-secondary); line-height: 1.6; font-weight: var(--weight-normal); }
  .offer-form-root .progress { width: 100%; max-width: 680px; margin-bottom: 28px; }
  .offer-form-root .progress__track { height: 3px; background: var(--border); border-radius: 99px; overflow: hidden; }
  .offer-form-root .progress__fill { height: 100%; background: var(--accent); border-radius: 99px; transition: width .4s cubic-bezier(.4,0,.2,1); }
  .offer-form-root .progress__labels { display: flex; justify-content: space-between; margin-top: 8px; }
  .offer-form-root .progress__label { font-size: var(--text-xs); font-weight: var(--weight-semibold); letter-spacing: .04em; text-transform: uppercase; color: var(--text-muted); transition: color .2s; }
  .offer-form-root .progress__label.active { color: var(--accent); }
  .offer-form-root .progress__label.done { color: var(--ok); }
  .offer-form-root .section-card { width: 100%; max-width: 680px; background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-lg); box-shadow: var(--shadow-sm); margin-bottom: 16px; overflow: hidden; transition: box-shadow .2s, border-color .2s; }
  .offer-form-root .section-card:focus-within { box-shadow: var(--shadow-md); border-color: #c5cae8; }
  .offer-form-root .section-header { display: flex; align-items: center; justify-content: space-between; padding: 20px 24px; cursor: pointer; user-select: none; position: relative; z-index: 1; }
  .offer-form-root .section-header__left { display: flex; align-items: center; gap: 12px; }
  .offer-form-root .section-icon { width: 36px; height: 36px; border-radius: var(--radius-sm); display: flex; align-items: center; justify-content: center; font-size: 16px; background: var(--accent-light); }
  .offer-form-root .section-header__title { font-size: var(--text-lg); font-weight: var(--weight-bold); color: var(--text-primary); letter-spacing: -.01em; }
  .offer-form-root .section-header__sub { font-size: var(--text-sm); font-weight: var(--weight-normal); color: var(--text-secondary); margin-top: 2px; }
  .offer-form-root .section-badge { display: inline-flex; align-items: center; gap: 5px; font-size: var(--text-xs); font-weight: var(--weight-semibold); letter-spacing: .04em; padding: 4px 10px; border-radius: 99px; border: 1.5px solid transparent; text-transform: uppercase; }
  .offer-form-root .badge-pending { background: #f3f4f6; color: var(--text-muted); border-color: var(--border); }
  .offer-form-root .badge-ok { background: var(--ok-light); color: var(--ok); border-color: #a7e9cc; }
  .offer-form-root .badge-flag { background: var(--flag-light); color: var(--flag); border-color: #f6d860; }
  .offer-form-root .section-body { padding: 0 24px 24px; border-top: 1px solid var(--border); animation: slideDown .2s ease; position: relative; z-index: 2; pointer-events: auto; }
  @keyframes slideDown { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: translateY(0); } }
  .offer-form-root .readonly-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 20px; }
  .offer-form-root .readonly-grid.single { grid-template-columns: 1fr; }
  .offer-form-root .readonly-field { background: #f8f9fc; border: 1px solid var(--border); border-radius: var(--radius-md); padding: 14px 16px; }
  .offer-form-root .readonly-field__label { font-size: var(--text-xs); font-weight: var(--weight-semibold); letter-spacing: .06em; text-transform: uppercase; color: var(--text-muted); margin-bottom: 4px; }
  .offer-form-root .readonly-field__value { font-size: var(--text-sm); font-weight: var(--weight-semibold); color: var(--text-primary); font-family: var(--mono); }
  .offer-form-root .readonly-field__value.text { font-family: var(--font); font-size: var(--text-sm); font-weight: var(--weight-medium); }
  .offer-form-root .readonly-badge { display: inline-flex; align-items: center; gap: 4px; font-size: var(--text-xs); font-weight: var(--weight-semibold); color: var(--text-muted); background: #eef0f4; border-radius: 4px; padding: 2px 6px; margin-left: 6px; vertical-align: middle; letter-spacing: .04em; }
  .offer-form-root .aid-row { display: grid; grid-template-columns: 1fr 2fr; gap: 10px; margin-top: 12px; align-items: start; }
  .offer-form-root .aid-row:first-of-type { margin-top: 20px; }
  .offer-form-root .input-wrap { position: relative; }
  .offer-form-root .input-wrap__prefix { position: relative; display: block; }
  .offer-form-root .input-label { display: block; font-size: var(--text-xs); font-weight: var(--weight-semibold); letter-spacing: .06em; text-transform: uppercase; color: var(--text-secondary); margin-bottom: 6px; }
  .offer-form-root .input-prefix { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); font-size: var(--text-sm); font-weight: var(--weight-medium); color: var(--text-muted); pointer-events: none; font-family: var(--mono); }
  .offer-form-root .input-prefix.input-prefix--money { font-weight: var(--weight-semibold); color: var(--text-primary); }
  .offer-form-root .input-money { font-family: var(--mono) !important; font-size: var(--text-sm) !important; font-weight: var(--weight-semibold) !important; color: var(--text-primary) !important; padding-left: 28px !important; }
  .offer-form-root .input-money:disabled { color: var(--text-primary) !important; }
  .offer-form-root input[type="text"], .offer-form-root input[type="number"], .offer-form-root textarea, .offer-form-root select { width: 100%; font-family: var(--font); font-size: var(--text-sm); font-weight: var(--weight-normal); color: var(--text-primary); background: var(--surface); border: 1.5px solid var(--border); border-radius: var(--radius-sm); padding: 10px 12px; outline: none; transition: border-color .15s, box-shadow .15s; -webkit-appearance: none; }
  .offer-form-root input[type="number"] { font-family: var(--mono); padding-left: 28px; }
  .offer-form-root input:focus, .offer-form-root textarea:focus, .offer-form-root select:focus { border-color: var(--border-focus); box-shadow: 0 0 0 3px rgba(103,114,229,.15); }
  .offer-form-root input[readonly], .offer-form-root input[disabled] { background: #f8f9fc; color: var(--text-secondary); cursor: not-allowed; }
  .offer-form-root textarea { resize: vertical; min-height: 60px; line-height: 1.5; }
  .offer-form-root select { background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%239da8ba' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 12px center; padding-right: 32px; cursor: pointer; }
  .offer-form-root .divider { height: 1px; background: var(--border); margin: 20px 0; }
  .offer-form-root .checkbox-row { display: flex; align-items: center; gap: 10px; cursor: pointer; margin-top: 16px; }
  .offer-form-root .checkbox-box { width: 18px; height: 18px; border-radius: 4px; border: 1.5px solid var(--border); background: var(--surface); display: flex; align-items: center; justify-content: center; flex-shrink: 0; transition: background .15s, border-color .15s; }
  .offer-form-root .checkbox-box.checked { background: var(--accent); border-color: var(--accent); color: #fff; }
  .offer-form-root .checkbox-label { font-size: var(--text-sm); font-weight: var(--weight-medium); color: var(--text-secondary); }
  .offer-form-root .review-actions { display: flex; gap: 8px; margin-top: 24px; padding-top: 20px; border-top: 1px solid var(--border); }
  .offer-form-root .review-actions.inline { margin-top: 0; padding-top: 0; border-top: none; }
  .offer-form-root .review-btn { flex: 1; display: flex; align-items: center; justify-content: center; gap: 7px; padding: 11px 16px; border-radius: var(--radius-sm); border: 1.5px solid; font-family: var(--font); font-size: var(--text-sm); font-weight: var(--weight-semibold); cursor: pointer; transition: all .15s; }
  .offer-form-root .review-btn.ok { border-color: #a7e9cc; background: var(--ok-light); color: var(--ok); }
  .offer-form-root .review-btn.ok:hover, .offer-form-root .review-btn.ok.active { background: var(--ok); color: #fff; border-color: var(--ok); box-shadow: 0 2px 8px rgba(30,166,114,.3); }
  .offer-form-root .review-btn.flag { border-color: #f6d860; background: var(--flag-light); color: var(--flag); }
  .offer-form-root .review-btn.flag:hover, .offer-form-root .review-btn.flag.active { background: var(--flag); color: #fff; border-color: var(--flag); box-shadow: 0 2px 8px rgba(227,160,8,.3); }
  .offer-form-root .review-btn:disabled { opacity: .5; cursor: not-allowed; }
  .offer-form-root .submit-area { width: 100%; max-width: 680px; margin-top: 8px; }
  .offer-form-root .submit-notice { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-md); padding: 16px 20px; display: flex; align-items: flex-start; gap: 12px; margin-bottom: 16px; font-size: var(--text-sm); font-weight: var(--weight-normal); color: var(--text-secondary); line-height: 1.5; }
  .offer-form-root .submit-notice__icon { font-size: 18px; flex-shrink: 0; margin-top: -1px; }
  .offer-form-root .submit-btn { width: 100%; padding: 15px; background: var(--accent); color: #fff; border: none; border-radius: var(--radius-md); font-family: var(--font); font-size: var(--text-base); font-weight: var(--weight-bold); letter-spacing: -.01em; cursor: pointer; transition: background .15s, box-shadow .15s, transform .1s; box-shadow: 0 2px 8px rgba(103,114,229,.4); }
  .offer-form-root .submit-btn:hover:not(:disabled) { background: #5563d0; box-shadow: 0 4px 16px rgba(103,114,229,.45); transform: translateY(-1px); }
  .offer-form-root .submit-btn:active:not(:disabled) { transform: translateY(0); }
  .offer-form-root .submit-btn:disabled { opacity: .5; cursor: not-allowed; box-shadow: none; }
  .offer-form-root .submit-meta { text-align: center; font-size: var(--text-xs); font-weight: var(--weight-normal); color: var(--text-muted); margin-top: 12px; line-height: 1.5; }
  .offer-form-root .chevron { font-size: 12px; color: var(--text-muted); transition: transform .2s; }
  .offer-form-root .chevron.open { transform: rotate(180deg); }
  .offer-form-root .step-num { width: 22px; height: 22px; border-radius: 50%; background: var(--border); color: var(--text-muted); font-size: var(--text-xs); font-weight: var(--weight-bold); display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .offer-form-root .step-num.done { background: var(--ok); color: #fff; }
  .offer-form-root .step-num.flag-s { background: var(--flag); color: #fff; }
  @media (max-width: 600px) { .offer-form-root .readonly-grid { grid-template-columns: 1fr; } .offer-form-root .aid-row { grid-template-columns: 1fr; } }
`;

export default function OfferLetterUploadPage() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const [formData, setFormData] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [sectionReviews, setSectionReviews] = useState({
    basicInfo: "",
    aidScholarships: "",
    additionalDetails: "",
  });
  const [missingReviews, setMissingReviews] = useState([]);
  const [testOptional, setTestOptional] = useState(false);
  const [reviewerComments, setReviewerComments] = useState("");
  const [openSection, setOpenSection] = useState("basicInfo");
  const navigate = useNavigate();

  // Check for pending submission after authentication
  useEffect(() => {
    const pendingSubmission = localStorage.getItem('pendingOfferSubmission');
    if (pendingSubmission && auth.currentUser) {
      try {
        const submissionData = JSON.parse(pendingSubmission);
        // Restore the form data and file
        setFormData(submissionData.formData);
        setSectionReviews(submissionData.sectionReviews);
        setTestOptional(submissionData.testOptional);
        if (submissionData.reviewerComments) setReviewerComments(submissionData.reviewerComments);
        
        // Clear the pending submission
        localStorage.removeItem('pendingOfferSubmission');
        
        // Auto-submit the form
        setTimeout(() => {
          handleSubmitInternal(
            submissionData.formData, 
            submissionData.sectionReviews, 
            submissionData.testOptional,
            submissionData.tempFileUrl,
            submissionData.fileName,
            submissionData.reviewerComments
          );
        }, 1000);
      } catch {
        localStorage.removeItem('pendingOfferSubmission');
      }
    }
  }, [auth.currentUser]);

  // Update missing reviews whenever section reviews change
  useEffect(() => {
    const unreviewed = [];
    if (sectionReviews.basicInfo !== "ok" && sectionReviews.basicInfo !== "flag") {
      unreviewed.push("School & Cost Information");
    }
    if (sectionReviews.aidScholarships !== "ok" && sectionReviews.aidScholarships !== "flag") {
      unreviewed.push("Financial Aid & Scholarships");
    }
    if (sectionReviews.additionalDetails !== "ok" && sectionReviews.additionalDetails !== "flag") {
      unreviewed.push("Student Information");
    }
    setMissingReviews(unreviewed);
  }, [sectionReviews]);

  /**
   * These fields will be parsed as numbers in our flattening function.
   */
  const numericFields = [
    "cost_of_attendance",
    "financial_aid",
    "merit_aid",
    "other_aid",
    "federal_money",
    "workstudy",
    "loans",
    "efc_or_sai",
    "composite_act",
    "composite_sat",
    "gpa",
  ];

  useEffect(() => {
    // Only run if a user is logged in
    const fetchUserDoc = async () => {
      try {
        const user = auth.currentUser;
        if (!user) return;

        const userRef = doc(db, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (!userSnap.exists()) return;

        const userData = userSnap.data() || {};

        setFormData((prev) => {
          if (!prev) return prev; // If formData is null, do nothing yet

          // Determine if testScore is SAT or ACT based on value
          let satScore = "";
          let actScore = "";
          
          if (userData.testScore && userData.testScore !== "") {
            const score = parseInt(userData.testScore);
            if (score >= 400 && score <= 1600) {
              // Likely SAT score
              satScore = userData.testScore;
            } else if (score >= 1 && score <= 36) {
              // Likely ACT score
              actScore = userData.testScore;
            }
          }

          return {
            ...prev,
            efc_or_sai: {
              ...prev.efc_or_sai,
              amount:
                userData.sai && userData.sai !== ""
                  ? userData.sai
                  : prev.efc_or_sai?.amount || "",
            },
            composite_sat:
              satScore || prev.composite_sat || "",
            composite_act:
              actScore || prev.composite_act || "",
            gpa:
              userData.gpa && userData.gpa !== "" ? userData.gpa : prev.gpa || "",
            state_of_residence:
              userData.state && userData.state !== ""
                ? userData.state
                : prev.state_of_residence || "",
            activities:
              userData.activities && userData.activities !== ""
                ? userData.activities
                : prev.activities || "",
          };
        });
      } catch {
        // Silently ignore autopopulate errors
      }
    };

    fetchUserDoc();
  }, [formData]); // Add formData as dependency to run when form is populated

  /**
   * Handle File Selection (PDF only).
   */
  const handleFileChange = async (event) => {
    if (!event.target.files) return;
    const originalFile = event.target.files[0];
    if (!originalFile) return;


    // Check if file is a PDF
    if (originalFile.type !== "application/pdf") {
      alert("Please select a PDF file only.");
      return;
    }

    // Set the file
    setFile(originalFile);
  };

  /**
   * Upload the file to our /api/analyze-offer endpoint and init formData
   */
  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file before uploading.");
      return;
    }
    setSubmitted(false);

    setLoading(true);
    setResponse(null);

    try {
      const uploadFormData = new FormData();
      uploadFormData.append("file", file);

      const ANALYZE_URL =
        process.env.NODE_ENV === "development"
          ? "http://127.0.0.1:5002/offers-5e23d/us-central1/analyzeOfferLetter"
          : "https://us-central1-offers-5e23d.cloudfunctions.net/analyzeOfferLetter";
      const apiResponse = await axios.post(ANALYZE_URL, uploadFormData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const structuredData = apiResponse.data.structuredData;
      const { analysisSkipped, reason, notOfferLetter } = apiResponse.data;
      const hasData = !!(structuredData?.school_name?.name || structuredData?.cost_of_attendance?.amount);

      if (notOfferLetter) {
        alert("We can't recognize this as an offer letter. Please contact pocketly@gmail.com");
        setResponse(apiResponse.data);
        setLoading(false);
        return;
      }

      if (analysisSkipped || !hasData) {
        alert(reason || "Could not extract data from the PDF. You can fill the form manually.");
      }

      setResponse(apiResponse.data);

      let schoolNameObject = { name: "" };
      if (structuredData?.school_name) {
        if (typeof structuredData.school_name === "object") {
          schoolNameObject = { name: structuredData.school_name.name || "" };
        } else if (typeof structuredData.school_name === "string") {
          schoolNameObject = { name: structuredData.school_name };
        }
      }

      setFormData({
        school_name: schoolNameObject,
        cost_of_attendance: {
          amount: structuredData?.cost_of_attendance?.amount || "",
          details: structuredData?.cost_of_attendance?.details || "",
        },
        financial_aid: {
          amount: structuredData?.financial_aid?.amount || "",
          details: structuredData?.financial_aid?.details || "",
        },
        merit_aid: {
          amount: structuredData?.merit_aid?.amount || "",
          details: structuredData?.merit_aid?.details || "",
        },
        other_aid: {
          amount: structuredData?.other_aid?.amount || "",
          details: structuredData?.other_aid?.details || "",
        },
        federal_money: {
          amount: structuredData?.federal_money?.amount || "",
          details: structuredData?.federal_money?.details || "",
        },
        loans: {
          amount: structuredData?.loans?.amount || "",
          details: structuredData?.loans?.details || "",
        },
        workstudy: {
          amount: structuredData?.workstudy?.amount || "",
          details: structuredData?.workstudy?.details || "",
        },
        efc_or_sai: {
          amount: structuredData?.efc_or_sai?.amount || "",
          details: structuredData?.efc_or_sai?.details || "",
        },
        composite_act: structuredData?.composite_act || "",
        composite_sat: structuredData?.composite_sat || "",
        gpa: structuredData?.gpa || "",
        state_of_residence: structuredData?.state_of_residence || "",
        admission_type: structuredData?.admission_type || "",
      });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const data = error.response.data;
        setResponse(data);
        const msg = data?.details || data?.reason || data?.error || "Analysis failed.";
        alert(msg + " You can fill the form manually.");
        // Still show empty form so user can enter data
        setFormData({
          school_name: { name: "" },
          cost_of_attendance: { amount: "", details: "" },
          financial_aid: { amount: "", details: "" },
          merit_aid: { amount: "", details: "" },
          other_aid: { amount: "", details: "" },
          federal_money: { amount: "", details: "" },
          loans: { amount: "", details: "" },
          workstudy: { amount: "", details: "" },
          efc_or_sai: { amount: "", details: "" },
          composite_act: "", composite_sat: "", gpa: "", state_of_residence: "", admission_type: ""
        });
      } else {
        alert("There was an error uploading your file. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  /**
   * Use stringSimilarity to find the closest school name from your Firestore
   */
  const findClosestSchool = async (schoolName) => {
    const allDataRef = doc(db, "collegeData", "allData");
    const allDataSnap = await getDoc(allDataRef);

    if (!allDataSnap.exists()) {
      return null;
    }

    const allSchools = allDataSnap.data();
    const schoolNames = Object.values(allSchools).map((school) => school.name);

    const bestMatch = stringSimilarity.findBestMatch(schoolName, schoolNames);
    const closestMatch = bestMatch.bestMatch.target;

    const matchedIpedsId = Object.keys(allSchools).find(
      (key) => allSchools[key].name === closestMatch
    );

    return matchedIpedsId || null;
  };

  /**
   * If subField is provided (e.g. "amount", "details"), update a nested object.
   */
  const handleChange = (field, subField, value) => {
    setFormData((prev) => {
      if (subField) {
        return {
          ...prev,
          [field]: {
            ...prev[field],
            [subField]: value,
          },
        };
      } else {
        return {
          ...prev,
          [field]: value,
        };
      }
    });
  };

  /**
   * Flatten nested objects for Firestore
   */
  const flattenFormData = (data) => {
    const result = {};

    for (const [key, value] of Object.entries(data)) {
      if (key === "school_name") {
        result[key] = value?.name || "";
      } else if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        const amt = value.amount ?? "";
        const det = value.details ?? "";

        if (numericFields.includes(key)) {
          const strippedValue = String(amt).replace(/,/g, "").trim();
          const parsedValue = parseFloat(strippedValue);
          result[key] = isNaN(parsedValue) ? 0 : parsedValue;
        } else {
          result[key] = amt;
        }

        result[`${key}_details`] = det;
      } else {
        if (numericFields.includes(key)) {
          const strippedValue = String(value || "").replace(/,/g, "").trim();
          const parsedValue = parseFloat(strippedValue);
          result[key] = isNaN(parsedValue) ? 0 : parsedValue;
        } else {
          result[key] = value;
        }
      }
    }

    return result;
  };

  /**
   * Submit to Firestore
   */
  const handleSubmit = async () => {
    // Check if user is authenticated
    if (!auth.currentUser) {
      // Upload file to temporary storage first
      if (!file) {
        alert("No file selected. Please upload a file first.");
        return;
      }

      setLoading(true);
      try {
        const storage = getStorage();
        const tempFileRef = ref(storage, `tempOfferLetters/${Date.now()}_${file.name}`);
        
        await uploadBytes(tempFileRef, file);
        const tempFileUrl = await getDownloadURL(tempFileRef);
        
        // Store form data and temporary file URL for later submission
        const submissionData = {
          formData,
          sectionReviews,
          testOptional,
          reviewerComments,
          tempFileUrl,
          fileName: file.name,
          timestamp: Date.now()
        };
        localStorage.setItem('pendingOfferSubmission', JSON.stringify(submissionData));
        
        setLoading(false);
        
        // Redirect to sign-in page
        navigate('/auth');
        return;
      } catch {
        alert("Failed to prepare submission. Please try again.");
        setLoading(false);
        return;
      }
    }

    // If authenticated, proceed with submission
    await handleSubmitInternal(formData, sectionReviews, testOptional, null, null, reviewerComments);
  };

  /**
   * Internal submit function (called after authentication)
   */
  const handleSubmitInternal = async (dataToSubmit, reviewsToSubmit, testOptionalToSubmit, tempFileUrl = null, fileName = null, commentsToReviewer = "") => {
    // Validate that all sections have been reviewed (must be either "ok" or "flag")
    const unreviewed = [];
    if (reviewsToSubmit.basicInfo !== "ok" && reviewsToSubmit.basicInfo !== "flag") {
      unreviewed.push("School & Cost Information");
    }
    if (reviewsToSubmit.aidScholarships !== "ok" && reviewsToSubmit.aidScholarships !== "flag") {
      unreviewed.push("Financial Aid & Scholarships");
    }
    if (reviewsToSubmit.additionalDetails !== "ok" && reviewsToSubmit.additionalDetails !== "flag") {
      unreviewed.push("Student Information");
    }

    if (unreviewed.length > 0) {
      setMissingReviews(unreviewed);
      alert(`Please review all sections before submitting. Missing reviews:\n• ${unreviewed.join('\n• ')}`);
      return;
    }

    setMissingReviews([]); // Clear any previous errors

    if (!dataToSubmit || !dataToSubmit.school_name) {
      alert("Missing school name. Cannot submit.");
      return;
    }

    if (!file && !tempFileUrl) {
      alert("No file selected. Please upload a file first.");
      return;
    }

    // Validate test scores or test optional selection
    if (!testOptionalToSubmit && !dataToSubmit?.composite_act && !dataToSubmit?.composite_sat) {
      alert("Please either select 'Test Optional' or provide at least one test score (ACT or SAT).");
      return;
    }

    // Validate admission type is selected
    if (!dataToSubmit?.admission_type) {
      alert("Please select an admission type.");
      return;
    }

    setLoading(true);

    try {
      const schoolName = dataToSubmit?.school_name?.name || "";

      if (!schoolName) {
        alert("No school name found in formData!");
        setLoading(false);
        return;
      }

      const ipedsId = await findClosestSchool(schoolName);

      if (!ipedsId) {
        alert("No matching school found!");
        setLoading(false);
        return;
      }

      const user = auth.currentUser;
      if (!user) {
        alert("User not authenticated!");
        setLoading(false);
        return;
      }

      const flattenedData = flattenFormData(dataToSubmit);
      const uniqueId = uuidv4();
      let fileUrl;

      if (tempFileUrl) {
        // Use the temporary file URL if available
        fileUrl = tempFileUrl;
      } else {
        // Upload the file normally
        const storage = getStorage();
        const fileRef = ref(storage, `offerLetters/${uniqueId}`);

        await uploadBytes(fileRef, file);
        fileUrl = await getDownloadURL(fileRef);
      }

      const batch = writeBatch(db);
      const currentDate = Timestamp.now();

      // Get sections that are flagged for review
      const flaggedSections = [];
      if (reviewsToSubmit.basicInfo === "flag") flaggedSections.push("basicInfo");
      if (reviewsToSubmit.aidScholarships === "flag") flaggedSections.push("aidScholarships");
      if (reviewsToSubmit.additionalDetails === "flag") flaggedSections.push("additionalDetails");

      const offerData = {
        ...flattenedData,
        test_optional: testOptionalToSubmit,
        schoolId: ipedsId,
        offerId: uniqueId,
        fileUrl: fileUrl,
        date: currentDate,
        sectionReviews: reviewsToSubmit,
        flaggedForReview: flaggedSections.length > 0,
        flaggedSections: flaggedSections,
        reviewerComments: commentsToReviewer || "",
        status: 'pending', // Always set status to pending
      };

      // Check if user has existing profile data
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.exists() ? userSnap.data() : {};
      
      // Prepare user profile updates
      const userProfileUpdates = {};
      let hasNewData = false;
      
      // Check if user is entering these details for the first time
      if (dataToSubmit?.efc_or_sai?.amount && (!userData.sai || userData.sai === "")) {
        userProfileUpdates.sai = dataToSubmit.efc_or_sai.amount;
        hasNewData = true;
      }
      
      // Handle test scores - prioritize SAT over ACT if both are present
      if ((dataToSubmit?.composite_sat || dataToSubmit?.composite_act) && (!userData.testScore || userData.testScore === "")) {
        if (dataToSubmit?.composite_sat) {
          userProfileUpdates.testScore = dataToSubmit.composite_sat;
        } else if (dataToSubmit?.composite_act) {
          userProfileUpdates.testScore = dataToSubmit.composite_act;
        }
        hasNewData = true;
      }
      
      if (dataToSubmit?.gpa && (!userData.gpa || userData.gpa === "")) {
        userProfileUpdates.gpa = dataToSubmit.gpa;
        hasNewData = true;
      }
      
      if (dataToSubmit?.state_of_residence && (!userData.state || userData.state === "")) {
        userProfileUpdates.state = dataToSubmit.state_of_residence;
        hasNewData = true;
      }

      // Add offer to user's offers array
      batch.update(userRef, {
        offers: arrayUnion(offerData),
        ...userProfileUpdates, // Include any new profile data
      });

      // Update the school's offer list and timestamp (create if doesn't exist)
      const offerLettersRef = doc(db, "offerLetters", ipedsId);
      batch.set(offerLettersRef, {
        offers: arrayUnion({
          ...offerData,
          uid: user.uid,
        }),
        lastOfferAdded: currentDate, // Track when the latest offer was added
        school_name: dataToSubmit?.school_name?.name || "Unknown School", // Store school name for reference
      }, { merge: true }); // Use merge to create document if it doesn't exist

      // Update the main college data
      const allDataRef = doc(db, "collegeData", "allData");
      const schoolDataPath = `${ipedsId}.offer_count`;
      batch.update(allDataRef, {
        [schoolDataPath]: increment(1),
        [`${ipedsId}.lastOfferAdded`]: currentDate, // Also track in main data
      });

      await batch.commit();

      // Show success message with profile update info if applicable
      if (hasNewData) {
        alert("Offer data successfully added! Your profile has been updated with the new information you provided.");
      } else {
        alert("Offer data successfully added!");
      }

      setSubmitted(true);
      setFormData(null);
      setResponse(null);
      setFile(null);
      setReviewerComments("");
      
      // Show success message instead of redirecting
      // navigate('/success');
    } catch (error) {
      const msg = error?.message || "";
      alert(msg.toLowerCase().includes("permission") 
        ? "Permission denied. Please sign in again and try again." 
        : "Failed to submit the offer data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const shouldShowDetails = (amount) => {
    return amount !== null && amount !== undefined && amount !== "" && amount !== 0;
  };

  const handleSectionReviewChange = (section, value) => {
    setSectionReviews((prev) => ({ ...prev, [section]: value }));
  };

  // ─── Adapters for new Stripe-style form UI (logic unchanged) ─────────────
  const formDataToUIData = () => {
    if (!formData) return null;
    const aidKeys = ["financial_aid", "merit_aid", "other_aid", "federal_money", "loans", "workstudy"];
    const aid = {};
    aidKeys.forEach((k) => {
      aid[k] = formData[k]?.amount ?? "";
      aid[`${k}_details`] = formData[k]?.details ?? "";
    });
    return {
      school_name: formData.school_name?.name ?? "",
      cost_of_attendance: formData.cost_of_attendance?.amount ?? "",
      cost_of_attendance_details: formData.cost_of_attendance?.details ?? "",
      ...aid,
      efc_or_sai: formData.efc_or_sai?.amount ?? "",
      efc_or_sai_details: formData.efc_or_sai?.details ?? "",
      composite_act: formData.composite_act ?? "",
      composite_sat: formData.composite_sat ?? "",
      testOptional,
      gpa: formData.gpa ?? "",
      state_of_residence: formData.state_of_residence ?? "",
      admission_type: formData.admission_type ?? "",
      activities: formData.activities ?? "",
    };
  };

  const handleUIChange = (key, value) => {
    if (key === "testOptional") {
      setTestOptional(value);
      return;
    }
    if (key.endsWith("_details")) {
      const field = key.replace(/_details$/, "");
      handleChange(field, "details", value);
      return;
    }
    const nested = ["efc_or_sai", "cost_of_attendance", "financial_aid", "merit_aid", "other_aid", "federal_money", "loans", "workstudy"];
    if (nested.includes(key)) {
      handleChange(key, "amount", value);
      return;
    }
    handleChange(key, undefined, value);
  };

  const handleUIReview = useCallback((section, value) => {
    handleSectionReviewChange(section, value === null ? "" : value);
  }, []);

  // Add this helper function inside the component
  const isStudentInfoComplete = () => {
    return (
      formData?.efc_or_sai?.amount &&
      (testOptional || formData?.composite_act || formData?.composite_sat) &&
      formData?.gpa &&
      formData?.state_of_residence &&
      formData?.admission_type
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50" style={{ fontFamily: "'DM Sans',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif" }}>
      {/* Navbar */}

      <div className="relative overflow-hidden min-h-screen flex flex-col items-center p-4">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/10 to-purple-600/10"></div>
        <div className="absolute inset-0 bg-[url('data:image/svg+xml,%3Csvg%20width%3D%2260%22%20height%3D%2260%22%20viewBox%3D%220%200%2060%2060%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Cg%20fill%3D%22none%22%20fill-rule%3D%22evenodd%22%3E%3Cg%20fill%3D%22%239C92AC%22%20fill-opacity%3D%220.05%22%3E%3Ccircle%20cx%3D%2230%22%20cy%3D%2230%22%20r%3D%222%22/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')] opacity-50"></div>
        
        <div className="relative w-full flex flex-col items-center">
        {/* Page Header - only show before upload */}
        {!formData && (
        <header className="text-center mb-8 max-w-4xl">
          <div className="inline-flex items-center px-3 py-1.5 bg-gradient-to-r from-blue-100 to-purple-100 rounded-full text-xs font-medium text-gray-700 mb-4">
            <svg className="w-3 h-3 mr-1.5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Secure • Private • Fast
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 leading-tight">
            Upload Your{" "}
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
              Offer Letter
            </span>
          </h1>
          <p className="text-base text-gray-600 mb-4 max-w-2xl mx-auto leading-relaxed">
            Upload a PDF of your offer letter.
            Our AI system will analyze it and categorize aid types.
          </p>
          
          {/* Feature highlights */}
          <div className="grid grid-cols-3 gap-4 max-w-xl mx-auto">
            <div className="flex items-center justify-center text-xs text-gray-600">
              <svg className="w-4 h-4 mr-1 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              Anonymous
            </div>
            <div className="flex items-center justify-center text-xs text-gray-600">
              <svg className="w-4 h-4 mr-1 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
              </svg>
              AI-Powered
            </div>
            <div className="flex items-center justify-center text-xs text-gray-600">
              <svg className="w-4 h-4 mr-1 text-purple-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
              </svg>
              Earn Money
            </div>
          </div>
        </header>
        )}

                 {/* Enhanced File Upload Card - Hide when form data exists */}
         {!formData && (
         <div className="w-full max-w-xl bg-white/80 backdrop-blur-sm p-6 rounded-2xl shadow-2xl border border-white/20 mb-6">
           <div className="text-center mb-4">
             <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full mb-3">
               <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
               </svg>
             </div>
             <h3 className="text-lg font-bold text-gray-900 mb-1">Choose Your File</h3>
             <p className="text-gray-600 text-sm">Drag and drop or click to select</p>
           </div>

           {/* Drag and Drop Upload Area */}
           <div className="relative">
             <input
               type="file"
               accept=".pdf"
               onChange={handleFileChange}
               className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
               id="file-upload"
             />
             <label
               htmlFor="file-upload"
               className={`flex flex-col items-center justify-center w-full h-32 border-2 border-dashed rounded-xl cursor-pointer transition-all duration-300 ${
                 file
                   ? "border-green-300 bg-green-50"
                   : "border-gray-300 bg-gray-50 hover:bg-gray-100 hover:border-gray-400"
               }`}
             >
               {file ? (
                 <div className="text-center">
                   <svg className="w-8 h-8 text-green-500 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                   </svg>
                   <p className="text-green-700 font-semibold text-sm">{file.name}</p>
                   <p className="text-green-600 text-xs">
                     {(file.size / 1024 / 1024).toFixed(2)} MB
                   </p>
                 </div>
               ) : (
                 <div className="text-center">
                   <svg className="w-8 h-8 text-gray-400 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
                   </svg>
                   <p className="text-gray-700 font-medium text-sm">Drop file here</p>
                   <p className="text-gray-500 text-xs">PDF files only (Max 10MB)</p>
                 </div>
               )}
             </label>
           </div>

           {/* Upload Button */}
           <div className="mt-4">
             <button
               onClick={handleUpload}
               disabled={loading || !file}
               className={`w-full py-3 px-4 rounded-xl font-semibold text-base transition-all duration-300 transform ${
                 loading
                   ? "bg-gray-400 cursor-not-allowed"
                   : !file
                   ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                   : "bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700 hover:scale-105 shadow-lg hover:shadow-xl"
               }`}
             >
               {loading ? (
                 <div className="flex items-center justify-center space-x-2">
                   <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                   </svg>
                   <span>Analyzing...</span>
                 </div>
               ) : !file ? (
                 "Select a file first"
               ) : (
                 <div className="flex items-center justify-center space-x-2">
                   <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                   </svg>
                   <span>Upload and Analyze</span>
                 </div>
               )}
             </button>
           </div>

           {/* Upload Progress/Status */}
           {loading && (
             <div className="mt-4 bg-blue-50 rounded-lg p-3">
               <div className="flex items-center text-blue-700">
                 <svg className="animate-pulse w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                   <path fillRule="evenodd" d="M11.3 1.046A1 1 0 0112 2v5h4a1 1 0 01.82 1.573l-7 10A1 1 0 018 18v-5H4a1 1 0 01-.82-1.573l7-10a1 1 0 011.12-.38z" clipRule="evenodd" />
                 </svg>
                 <span className="font-medium text-sm">AI analyzing document...</span>
               </div>
               <div className="mt-2 bg-blue-200 rounded-full h-1.5">
                 <div className="bg-blue-600 h-1.5 rounded-full animate-pulse" style={{ width: '60%' }}></div>
               </div>
             </div>
           )}
         </div>
         )}

                 {/* Information Cards */}
   

        {/* If we have formData, show the Stripe-style form */}
        {!submitted && formData && (() => {
          const uiData = formDataToUIData();
          if (!uiData) return null;
          const fmt = (n) => { if (!n && n !== 0) return "—"; return "$" + Number(n).toLocaleString(); };
          const fmtNum = (n) => { if (!n && n !== 0) return "—"; return Number(n).toLocaleString(); };
          const allReviewed = sectionReviews.basicInfo && sectionReviews.aidScholarships && sectionReviews.additionalDetails;
          const sectionStatus = (s) => (sectionReviews[s] || null);
          const progress = [sectionReviews.basicInfo, sectionReviews.aidScholarships, sectionReviews.additionalDetails].filter(Boolean).length;
          const progressPct = `${(progress / 3) * 100}%`;
          const toggle = (k) => setOpenSection((p) => (p === k ? null : k));
          const collapseSection = (k) => setOpenSection((p) => (p === k ? null : p));
          const CheckIcon = () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>;
          const FlagIcon = () => <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2h8L8 6l2 4H2V2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>;
          const SectionBadge = ({ status }) => {
            if (status === "ok") return <span className="section-badge badge-ok"><CheckIcon/> Looks Good</span>;
            if (status === "flag") return <span className="section-badge badge-flag"><FlagIcon/> Flagged</span>;
            return <span className="section-badge badge-pending">Review Required</span>;
          };
          const StepNum = ({ idx, status }) => {
            const cls = status === "ok" ? "done" : status === "flag" ? "flag-s" : "";
            return <div className={`step-num ${cls}`}>{status === "ok" ? "✓" : status === "flag" ? "!" : idx}</div>;
          };
          const additionalDetailsRequiredValid = () => {
            const efc = (uiData.efc_or_sai ?? "").toString().trim();
            const hasTestScore = ((uiData.composite_act ?? "").toString().trim() !== "") || ((uiData.composite_sat ?? "").toString().trim() !== "") || (uiData.testOptional === true);
            const gpa = (uiData.gpa ?? "").toString().trim();
            const state = (uiData.state_of_residence ?? "").toString().trim();
            const admission = (uiData.admission_type ?? "").toString().trim();
            return efc !== "" && hasTestScore && gpa !== "" && state.length === 2 && admission !== "";
          };
          const ReviewActions = ({ sectionKey, status, onReview, onCollapse, canMarkLooksGood = true }) => {
            const handleOk = (e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!canMarkLooksGood) return;
              onReview(sectionKey, status === "ok" ? null : "ok");
              onCollapse?.(sectionKey);
            };
            const handleFlag = (e) => {
              e.preventDefault();
              e.stopPropagation();
              onReview(sectionKey, status === "flag" ? null : "flag");
              onCollapse?.(sectionKey);
            };
            return (
              <div className="review-actions" style={{ pointerEvents: "auto" }}>
                <button
                  type="button"
                  className={`review-btn ok ${status === "ok" ? "active" : ""}`}
                  onPointerUp={handleOk}
                  disabled={!canMarkLooksGood}
                >
                  <CheckIcon /> Looks Good
                </button>
                <button
                  type="button"
                  className={`review-btn flag ${status === "flag" ? "active" : ""}`}
                  onPointerUp={handleFlag}
                >
                  <FlagIcon /> Flag for Review
                </button>
              </div>
            );
          };
          const ReadonlyField = ({ label, value, mono, full }) => (
            <div className="readonly-field" style={full ? { gridColumn: "1 / -1" } : {}}>
              <div className="readonly-field__label">{label}<span className="readonly-badge">AI</span></div>
              <div className={`readonly-field__value ${mono ? "" : "text"}`}>{value || "—"}</div>
            </div>
          );
          const AID_FIELDS = [{ key: "financial_aid", label: "Financial Aid" }, { key: "merit_aid", label: "Merit Aid" }, { key: "other_aid", label: "Other Aid" }, { key: "federal_money", label: "Federal Aid" }, { key: "loans", label: "Loans" }, { key: "workstudy", label: "Work-Study" }];
          const ADMISSION_TYPES = ["Early Decision", "Early Action", "Regular Decision", "Rolling Admission", "Deferred Admission"];
          return (
            <>
              <style>{FORM_CSS}</style>
              <div className="offer-form-root" style={{ width: "100%", marginTop: 48 }}>
                <div className="form-inner">
                  {(!formData?.school_name?.name && [formData?.cost_of_attendance?.amount, formData?.financial_aid?.amount, formData?.merit_aid?.amount].every((v) => v === undefined || v === null || v === 0 || v === "")) && (
                    <div style={{ marginBottom: 24, padding: 16, background: "#fef9e7", border: "1px solid #f6d860", borderRadius: 10, fontSize: 14, color: "#92400e" }}>
                      <strong>No data was extracted from this PDF.</strong> It may be a scanned/image-only document. You can still fill in the fields below manually, or try uploading a text-based PDF.
                    </div>
                  )}
                  <div className="form-header">
                    <div className="form-header__eyebrow"><div className="form-header__eyebrow-dot" />Offer Letter Review</div>
                    <h1 className="form-header__title">Review your <span className="gradient-text">financial aid</span> offer</h1>
                    <p className="form-header__sub">We've extracted your offer details with AI. Confirm each section looks correct, flag anything that needs attention, then submit.</p>
                  </div>
                  <div className="progress">
                    <div className="progress__track"><div className="progress__fill" style={{ width: progressPct }} /></div>
                    <div className="progress__labels">
                      {["School & Cost", "Financial Aid", "Student Info"].map((l, i) => {
                        const keys = ["basicInfo", "aidScholarships", "additionalDetails"];
                        const s = sectionReviews[keys[i]];
                        return <span key={l} className={`progress__label ${s ? "done" : i === progress ? "active" : ""}`}>{l}</span>;
                      })}
                    </div>
                  </div>
                  {/* Section 1: School & Cost */}
                  <div className="section-card">
                    <div className="section-header" onClick={() => toggle("basicInfo")}>
                      <div className="section-header__left">
                        <StepNum idx={1} status={sectionStatus("basicInfo")} />
                        <div className="section-icon">🏫</div>
                        <div>
                          <div className="section-header__title">School & Cost</div>
                          <div className="section-header__sub">Institution and total cost of attendance</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <SectionBadge status={sectionStatus("basicInfo")} />
                        <span className={`chevron ${openSection === "basicInfo" ? "open" : ""}`}>▼</span>
                      </div>
                    </div>
                    {openSection === "basicInfo" && (
                      <div className="section-body">
                        <div className="readonly-grid">
                          <ReadonlyField label="School Name" value={uiData.school_name} />
                          <ReadonlyField label="Cost of Attendance" value={fmt(uiData.cost_of_attendance)} mono />
                          {uiData.cost_of_attendance_details && <ReadonlyField label="Cost Details" value={uiData.cost_of_attendance_details} full />}
                        </div>
                        <ReviewActions sectionKey="basicInfo" status={sectionStatus("basicInfo")} onReview={handleUIReview} onCollapse={collapseSection} />
                      </div>
                    )}
                  </div>
                  {/* Section 2: Financial Aid */}
                  <div className="section-card">
                    <div className="section-header" onClick={() => toggle("aidScholarships")}>
                      <div className="section-header__left">
                        <StepNum idx={2} status={sectionStatus("aidScholarships")} />
                        <div className="section-icon">💰</div>
                        <div>
                          <div className="section-header__title">Financial Aid & Scholarships</div>
                          <div className="section-header__sub">Aid amounts are AI-extracted; add notes as needed</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <SectionBadge status={sectionStatus("aidScholarships")} />
                        <span className={`chevron ${openSection === "aidScholarships" ? "open" : ""}`}>▼</span>
                      </div>
                    </div>
                    {openSection === "aidScholarships" && (
                      <div className="section-body">
                        {AID_FIELDS.map(({ key, label }) => (
                          <div className="aid-row" key={key}>
                            <div className="input-wrap">
                              <label className="input-label">{label}</label>
                              <div className="input-wrap__prefix">
                                <span className="input-prefix input-prefix--money">$</span>
                                <input type="text" className="input-money" value={fmtNum(uiData[key])} readOnly disabled />
                              </div>
                            </div>
                            <div className="input-wrap">
                              <label className="input-label">Notes</label>
                              <textarea value={uiData[`${key}_details`] || ""} onChange={(e) => handleUIChange(`${key}_details`, e.target.value)} placeholder="Add breakdown or notes…" rows={2} />
                            </div>
                          </div>
                        ))}
                        <ReviewActions sectionKey="aidScholarships" status={sectionStatus("aidScholarships")} onReview={handleUIReview} onCollapse={collapseSection} />
                      </div>
                    )}
                  </div>
                  {/* Section 3: Student Info */}
                  <div className="section-card">
                    <div className="section-header" onClick={() => toggle("additionalDetails")}>
                      <div className="section-header__left">
                        <StepNum idx={3} status={sectionStatus("additionalDetails")} />
                        <div className="section-icon">🎓</div>
                        <div>
                          <div className="section-header__title">Student Information</div>
                          <div className="section-header__sub">Academic profile and admission details</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <SectionBadge status={sectionStatus("additionalDetails")} />
                        <span className={`chevron ${openSection === "additionalDetails" ? "open" : ""}`}>▼</span>
                      </div>
                    </div>
                    {openSection === "additionalDetails" && (
                      <div className="section-body">
                        <div style={{ marginTop: 20 }}>
                          <div className="readonly-grid">
                            <div className="input-wrap">
                              <label className="input-label">SAI / EFC <span style={{ color: "var(--danger)", fontWeight: 700 }}>*</span></label>
                              <div className="input-wrap__prefix">
                                <span className="input-prefix input-prefix--money">$</span>
                                <input type="text" className="input-money" value={uiData.efc_or_sai ?? ""} onChange={(e) => handleUIChange("efc_or_sai", e.target.value)} />
                              </div>
                            </div>
                            <div className="input-wrap">
                              <label className="input-label">Notes</label>
                              <textarea value={uiData.efc_or_sai_details || ""} onChange={(e) => handleUIChange("efc_or_sai_details", e.target.value)} placeholder="Optional notes…" rows={2} />
                            </div>
                          </div>
                        </div>
                        <div className="divider" />
                        <div className="readonly-grid">
                          <div className="input-wrap">
                            <label className="input-label">ACT Score <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>(1–36)</span></label>
                            <input type="text" value={uiData.composite_act ?? ""} onChange={(e) => handleUIChange("composite_act", e.target.value)} disabled={uiData.testOptional} style={{ paddingLeft: 12 }} />
                          </div>
                          <div className="input-wrap">
                            <label className="input-label">SAT Score <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>(400–1600)</span></label>
                            <input type="text" value={uiData.composite_sat ?? ""} onChange={(e) => handleUIChange("composite_sat", e.target.value)} disabled={uiData.testOptional} style={{ paddingLeft: 12 }} />
                          </div>
                        </div>
                        <label className="checkbox-row" onClick={() => handleUIChange("testOptional", !uiData.testOptional)}>
                          <div className={`checkbox-box ${uiData.testOptional ? "checked" : ""}`}>{uiData.testOptional && <CheckIcon />}</div>
                          <span className="checkbox-label">Test Optional — I did not submit test scores <span style={{ color: "var(--danger)", fontWeight: 700 }}>*</span> <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>(or fill ACT/SAT above)</span></span>
                        </label>
                        <div className="divider" />
                        <div className="readonly-grid">
                          <div className="input-wrap">
                            <label className="input-label">GPA <span style={{ color: "var(--danger)", fontWeight: 700 }}>*</span></label>
                            <input type="text" value={uiData.gpa ?? ""} onChange={(e) => handleUIChange("gpa", e.target.value)} style={{ paddingLeft: 12 }} />
                          </div>
                          <div className="input-wrap">
                            <label className="input-label">State of Residence <span style={{ color: "var(--danger)", fontWeight: 700 }}>*</span></label>
                            <input type="text" value={uiData.state_of_residence || ""} onChange={(e) => { const v = e.target.value.toUpperCase(); if (v.length <= 2) handleUIChange("state_of_residence", v); }} placeholder="CA" maxLength={2} style={{ textTransform: "uppercase", letterSpacing: ".1em", fontWeight: 600 }} />
                          </div>
                        </div>
                        <div style={{ marginTop: 12 }}>
                          <div className="input-wrap">
                            <label className="input-label">Admission Type <span style={{ color: "var(--danger)", fontWeight: 700 }}>*</span></label>
                            <select value={uiData.admission_type || ""} onChange={(e) => handleUIChange("admission_type", e.target.value)}>
                              <option value="">Select admission type…</option>
                              {ADMISSION_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                            </select>
                          </div>
                        </div>
                        <div style={{ marginTop: 12 }}>
                          <div className="input-wrap">
                            <label className="input-label">Activities & Extracurriculars</label>
                            <textarea value={uiData.activities || ""} onChange={(e) => handleUIChange("activities", e.target.value)} placeholder="Clubs, sports, volunteer work, leadership roles…" rows={3} />
                          </div>
                        </div>
                        <ReviewActions sectionKey="additionalDetails" status={sectionStatus("additionalDetails")} onReview={handleUIReview} onCollapse={collapseSection} canMarkLooksGood={additionalDetailsRequiredValid()} />
                      </div>
                    )}
                  </div>
                  {/* Submit */}
                  <div className="submit-area">
                    {!allReviewed && (
                      <div className="submit-notice">
                        <span className="submit-notice__icon">ℹ️</span>
                        <span>Review all three sections above — mark each as <strong>Looks Good</strong> or <strong>Flag for Review</strong> — before submitting.</span>
                      </div>
                    )}
                    {!auth.currentUser && allReviewed && (
                      <div className="submit-notice">
                        <span className="submit-notice__icon">🔐</span>
                        <span>You'll need to sign in to submit your offer letter. Your data will be saved and submitted automatically after authentication.</span>
                      </div>
                    )}
                    <div className="input-wrap" style={{ marginBottom: 16 }}>
                      <label className="input-label">Comments for Reviewer (optional)</label>
                      <textarea
                        value={reviewerComments}
                        onChange={(e) => setReviewerComments(e.target.value)}
                        placeholder="Add any comments for the review team — e.g. changes needed, errors to fix, or context about your offer."
                        rows={3}
                      />
                    </div>
                    <button type="button" className="submit-btn" disabled={!allReviewed || !uiData.admission_type || loading} onClick={handleSubmit}>
                      {loading ? "Submitting…" : (allReviewed ? (!auth.currentUser ? "Sign In to Submit" : "Submit Offer Letter →") : "Complete Reviews to Submit")}
                    </button>
                    <p className="submit-meta">
                      Submitted letters are status: <strong>pending</strong> and visible to our review team.
                      {(sectionReviews.basicInfo === "flag" || sectionReviews.aidScholarships === "flag" || sectionReviews.additionalDetails === "flag") ? " Flagged sections will be prioritized for review." : ""}
                    </p>
                  </div>
                </div>
              </div>
            </>
          );
        })()}

        {/* Success message with modern design */}
        {submitted && (
          <div className="w-full max-w-4xl mt-12 bg-gradient-to-br from-green-50 to-emerald-50 p-8 rounded-2xl shadow-2xl border border-green-200">
            <div className="text-center space-y-6">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-green-400 to-emerald-500 rounded-full mb-4">
                <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h2 className="text-4xl font-bold bg-gradient-to-r from-green-700 to-emerald-600 bg-clip-text text-transparent mb-4">
                  Submission Received
                </h2>
                <p className="text-green-700 text-lg font-medium mb-6">
                  Your offer has been submitted. Our team will review it within 24 hours to confirm.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <button
                    onClick={() => window.location.reload()}
                    className="px-6 py-3 bg-white text-green-700 rounded-xl font-semibold border-2 border-green-300 hover:bg-green-50 transition-all"
                  >
                    Upload Another Letter
                  </button>
                  <button
                    onClick={() => window.location.href = '/profile'}
                    className="px-6 py-3 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-xl font-semibold hover:from-green-700 hover:to-emerald-700 transition-all"
                  >
                    View My Profile
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
